import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-5 py-8 sm:py-16 items-center justify-center bg-[#0A0A0A]" data-id="element-126">
      {/* Logo */}
      <span className="text-[#FF6B00] text-lg sm:text-xl font-black tracking-widest mb-3 uppercase" data-id="element-127">
        🏀 BASKET PRONTO
      </span>

      {/* Badge */}
      <div className="mb-4" data-id="element-128">
        <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide border border-[#FF6B00]/20" data-id="element-129">
          🏀 Oltre 500 allenatori già soddisfatti
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-3xl sm:text-5xl md:text-7xl leading-[1.1] mb-4 tracking-tight" data-id="element-130">
        Pianifica un intero anno di basket{' '}
        <span className="text-[#FF6B00]" data-id="element-131">in soli 5 minuti.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-lg max-w-2xl mx-auto mb-5 font-medium leading-relaxed" data-id="element-132">
        Allenamenti pronti. Progressioni per ogni categoria. 101 esercizi
        professionali. Gestione della squadra.
      </p>

      {/* Bullets — compact */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-6 max-w-2xl" data-id="element-133">
        {['6 Volumi', '6 Bonus', '150 Allenamenti', '101 Esercizi', 'Tutte le Categorie'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-134">
            <span className="text-[#00C853] text-sm" data-id="element-135">✅</span>
            <span className="text-white text-xs sm:text-sm font-semibold" data-id="element-136">
              {item}
            </span>
          </div>)}
      </div>

      {/* Mockup image — smaller */}
      <div className="relative w-full max-w-[220px] sm:max-w-[360px] mx-auto mb-6" data-id="element-137">
        <img src="https://cdn.magicpatterns.com/uploads/gCMFb9oDWeUxJw7jiw69oL/ChatGPT_Image_29_may_2026,_13_27_50-Photoroom.png" alt="BASKET PRONTO — Il Kit Completo" className="w-full h-auto object-contain drop-shadow-2xl" width={600} height={600} fetchPriority="high" data-id="element-138" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-10 bg-[#FF6B00] opacity-20 rounded-full pointer-events-none" style={{
        filter: 'blur(40px)'
      }} data-id="element-139" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-6 rounded-2xl transition-colors inline-block mb-4 w-full sm:w-auto max-w-md shadow-xl" data-id="element-140">
        🚀 VOGLIO BASKET PRONTO ORA
      </a>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-[#B0B0C0] text-[11px] sm:text-sm font-medium" data-id="element-141">
        <span className="flex items-center gap-1.5" data-id="element-142">🔒 Pagamento Sicuro</span>
        <span className="flex items-center gap-1.5" data-id="element-143">⚡ Accesso Immediato</span>
        <span className="flex items-center gap-1.5" data-id="element-144">🛡️ Garanzia 7 Giorni</span>
      </div>
    </section>;
}